// Language utility functions for localStorage management
import { createLogger } from "./logger";
const logger = createLogger("LanguageUtils");
const LANGUAGE_STORAGE_KEY = "pani_language_preference";

// Get language from localStorage
export const getStoredLanguage = () => {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return stored && ["en", "fr"].includes(stored) ? stored : "en";
  } catch (error) {
    logger.error("Error reading language from localStorage:", error);
    return "en";
  }
};

// Save language to localStorage
export const saveLanguageToStorage = (language) => {
  try {
    if (["en", "fr"].includes(language)) {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    }
  } catch (error) {
    logger.error("Error saving language to localStorage:", error);
  }
};

// Remove language from localStorage
export const clearStoredLanguage = () => {
  try {
    localStorage.removeItem(LANGUAGE_STORAGE_KEY);
  } catch (error) {
    logger.error("Error clearing language from localStorage:", error);
  }
};

// Get browser language preference
export const getBrowserLanguage = () => {
  try {
    const browserLang = navigator.language || navigator.userLanguage;
    return browserLang.startsWith("fr") ? "fr" : "en";
  } catch (error) {
    logger.error("Error getting browser language:", error);
    return "en";
  }
};

// Get initial language (priority: stored > browser > default)
export const getInitialLanguage = () => {
  const stored = getStoredLanguage();
  if (stored !== "en") return stored; // If stored is not default, use it

  const browser = getBrowserLanguage();
  return browser;
};
